import "./sponsors-section.scss";
import React from "react";

const SponsorsSection = () => {
   return (
      <section className="sponsors-section">
         <div className="container">
            <div className="sponsors-section__divider" />
            <div className="row align-items-center">
               <div className="col-xl col-md-4 flex-xl-grow-0 order-1 d-flex d-md-block justify-content-center">
                  <div className="sponsors-section__logo sponsors-section__logo--1 d-flex align-items-center justify-content-center">
                     <img
                        src={
                           require("assets/images/sponsors/komitet-do-spraw-pozytku-publicznego.jpg")
                              .default
                        }
                        alt="Logo KDSPP"
                     />
                  </div>
               </div>
               <div className="col-xl col-md-4 flex-xl-grow-0 order-2 d-flex d-xl-block justify-content-center">
                  <div className="sponsors-section__logo sponsors-section__logo--2 d-flex align-items-center justify-content-center justify-content-xl-end">
                     <img
                        src={
                           require("assets/images/sponsors/narodowy-instytut-wolnosci.jpg")
                              .default
                        }
                        alt="Logo NIW"
                     />
                  </div>
               </div>
               <div className="col-xl col-md-4 flex-xl-grow-0 order-3 order-xl-4 d-flex d-xl-block justify-content-center justify-content-md-end">
                  <div className="sponsors-section__logo sponsors-section__logo--3 d-flex align-items-center justify-content-center">
                     <img
                        src={
                           require("assets/images/sponsors/program-fundusz-inicjatyw-obywatelskich.jpg")
                              .default
                        }
                        alt="Logo FIO"
                     />
                  </div>
               </div>
               <div className="col-xl col-md-12 flex-xl-grow-1 order-4 order-xl-3">
                  <div className="sponsors-section__text">
                     <p>
                        <strong>
                           Sfinansowano przez Narodowy Instytut Wolności
                           <br />- Centrum Rozwoju Społeczeństwa Obywatelskiego
                        </strong>
                        <br />
                        ze środków Rządowego Programu Fundusz Inicjatyw
                        Obywatelskich
                        <br />
                        NOWE FIO na lata 2021-2030
                     </p>
                  </div>
               </div>

            </div>
         </div>
      </section>
   );
};

export default SponsorsSection;
